import React from "react";
import { TypeaheadFormField, TypeaheadProps } from "~/components/typeahead";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import { useServiceDescriptionsAsync } from "~/refdata2/serviceDescriptions";
import { createSearchRegex } from "~/components/text-highlighter/createSearchRegex";
import { TextHighlighter } from "~/components/text-highlighter";
import _ from "lodash";

const format = (item: string, searchText: string): React.ReactNode => {
  const searchRegex = createSearchRegex(searchText);

  return (
    <div className="industry-picker-menuitem">
      <TextHighlighter text={item} search={searchRegex} />
    </div>
  );
};

const chipFormat = (item: string) => item;

export const IndustryPickerFormField: React.FC<FormFieldProps> = (props) => {
  const getItems = useServiceDescriptionsAsync();

  const getData = async (searchText: string) => {
    const result = (await getItems()) ?? [];
    const uniqueResults = _.uniqBy(result, "industry");

    if (!searchText) {
      return uniqueResults.map((x) => x.industry);
    }

    return uniqueResults
      .filter((t) =>
        t.industry.toLowerCase().includes(searchText.toLowerCase())
      )
      .map((x) => x.industry);
  };

  const args = {
    ...props,
    getData,
    format,
    chipFormat,
  } as TypeaheadProps<string>;

  return <TypeaheadFormField {...args} />;
};
